import { jwtDecode } from "jwt-decode"

const DefaultTimeout = 60000;


export function isJwtExpired(jwt) {
    try {
        const decoded = jwtDecode(jwt);
        return !jwt || !decoded || new Date(decoded.exp * 1000) < new Date();
    } catch (ex) {
        return true;
    }
}

export async function sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => ("00" + b.toString(16)).slice(-2)).join("");
}

export async function get(url, headers) {
    return await (await fetchGet(url, headers)).json();
}

export async function deleteRequest(url, headers) {
    return await (await fetchDelete(url, headers)).json();
}

export async function post(url, payload, headers) {
    return await (await fetchPost(url, payload, headers)).json();
}

export async function put(url, payload, headers) {
    return await (await fetchPut(url, payload, headers)).json();
}

export function getHeaders(inlcudeAuth = false) {
    const headers = {
        "Content-Type": "application/json",
    };

    if (inlcudeAuth) {
        const token = localStorage.getItem("jwt");

        if (isJwtExpired(token)) {
            /*toast.error("Session Expired. Please login again",
                {
                    closeOnClick: false,
                    autoClose: 5000,
                }
            );*/
            window.location.href = window.location.origin;
        }

        headers["Authorization"] = `Bearer ${token}`;
    }

    return headers;
}

export function fetchGet(url, headers, timeout = DefaultTimeout) {
    const fetchPromise = fetch(url, {
        method: "get",
        headers,
    })
        .then((response) => {
            if (response.status === 401) {
                window.location.href = `${window.location.origin}/login`;
            }
            if (response.status === 403) {
                window.location.href = `${window.location.origin}/login`;
            }

            return response;
        })
        .catch((err) => {
            console.log('fetchGet error', err);
        });

    const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error("Request timed out"));
        }, timeout);
    });

    return Promise.race([fetchPromise, timeoutPromise]);
}

function fetchDelete(url, headers, timeout = DefaultTimeout) {
    const fetchPromise = fetch(url, {
        method: "delete",
        headers,
    });

    const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error("Request timed out"));
        }, timeout);
    });

    return Promise.race([fetchPromise, timeoutPromise]);
}

function fetchPut(url, payload, headers, timeout = DefaultTimeout) {
    const fetchPromise = fetch(url, {
        method: "put",
        headers,
        body: JSON.stringify(payload),
    });

    const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error("Request timed out"));
        }, timeout);
    });

    return Promise.race([fetchPromise, timeoutPromise]);
}

function fetchPost(url, payload, headers, timeout = DefaultTimeout) {
    const fetchPromise = fetch(url, {
        method: "post",
        headers,
        body: JSON.stringify(payload),
    });

    const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error("Request timed out"));
        }, timeout);
    });

    return Promise.race([fetchPromise, timeoutPromise]);
}
